import { useCallback } from 'react';

import { FEATURE_FLAGS_URL, IMPORT_SUBPATH } from 'api/FeatureFlagsAPI';
import { ApiMethod } from 'services/api';
import { useRestMutation } from 'utils/hooks/api';
import { useToastNotification } from 'utils/hooks/useToastNotification';
import { IdType, ImportType } from 'modules/domains/adminApp';

import { ImportIdsToFeatureFlagRequestBody, ImportIdsToFeatureFlagResponseBody } from '../types';
import { SUCCESS_MESSAGE, UNKNOWN_ERROR_MESSAGE } from '../constants';
import { useFeatureContext } from '../FeatureContext';

export const useImportMutation = (idType: IdType, importType: ImportType, comment: string) => {
  const { featureFlag } = useFeatureContext();
  const { mutate, data, isLoading, isError, isSuccess } = useRestMutation<
    ImportIdsToFeatureFlagResponseBody,
    ImportIdsToFeatureFlagRequestBody
  >(`${FEATURE_FLAGS_URL}/${featureFlag.feature}/${IMPORT_SUBPATH}`, ApiMethod.post);

  useToastNotification({
    enabled: isError,
    negative: true,
    negativeMessage: UNKNOWN_ERROR_MESSAGE,
  });

  useToastNotification({
    enabled: isSuccess,
    positive: true,
    positiveMessage: SUCCESS_MESSAGE,
  });

  const importIds = useCallback(
    () =>
      mutate({
        comment,
        currentVersion: featureFlag.currentVersion,
        idType,
        importType,
        notes: featureFlag.notes,
      }),
    [featureFlag, mutate, idType, importType],
  );

  return {
    importIds,
    changelogEntry: data,
    isLoading,
    didImport: isSuccess,
  };
};
